import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs/internal/Observable';
import {
  AcceptAuthorizationVerbiageRequestV1,
  AcceptAuthorizationVerbiageResponseV1,
  RetrieveAuthorizationVerbiageRequestV1,
  RetrieveAuthorizationVerbiageResponseV1,
} from '../models';

export abstract class PaymentAuthorizationVerbiageService {
  protected baseUrl: string;

  constructor(protected appConfig: AppConfigSettings) {
    this.baseUrl = this.appConfig.getconfig(
      'paymentAuthorizationVerbiageServiceUrl',
    );
  }

  abstract retrieveAuthorizationVerbiageV1(
    tenantId: string,
    retrieveVerbiageRequest: RetrieveAuthorizationVerbiageRequestV1,
  ): Observable<RetrieveAuthorizationVerbiageResponseV1>;

  abstract acceptAuthorizationVerbiageV1(
    tenantId: string,
    acceptVerbiageRequest: AcceptAuthorizationVerbiageRequestV1,
  ): Observable<AcceptAuthorizationVerbiageResponseV1>;
}
